import React from 'react';
import { apiHolder as api } from 'api';
import WriteLetterWeb from './WriteLetterWeb/WriteLetterWeb';
const WriteLetter = (props) => {
    const systemApi = api.api.getSystemApi();
    const inElectron = systemApi.isElectron();
    let res = React.createElement("div", null);
    if (!inElectron) {
        res = React.createElement(WriteLetterWeb, null);
    }
    return res;
};
export default WriteLetter;
